module.exports = __webpack_public_path__ + "static/img/1_9_2.a7e0ff7f.jpg";